import React, { useState, useEffect } from 'react';

import '../App.css';
import twitter from '../images/twitter.svg'
import medium from '../images/medium.svg'
import link from '../images/linkedin.svg'
import git from '../images/git.svg'
import fabio from '../images/web_fabio_profile.jpg'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import fire from '../components/Firebase'

function Home() {
    const [items, setItems] = useState();
    const [focus, setFocus] = useState("apps");
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (!isLoaded) {
            loadItems("apps");
            setIsLoaded(true);
        }
    }, [isLoaded]);

    const categories = ['apps', 'ux', 'articles'];

    function toggleFocus(currentFocus) {
        const currentIndex = categories.indexOf(currentFocus);
        const nextIndex = (currentIndex + 1) % categories.length;
        const newFocus = categories[nextIndex];

        setFocus(newFocus);
        loadItems(newFocus);
    }

    function loadItems(focusType) {
        fire
            .collection('items')
            .where('type', '==', focusType)
            .get().then((snap) => {
                setItems(snap.docs);
            }).catch((err) => console.log(err))
    }

    return (
        <div className="App">
            <div className="modern-layout">
                {/* Header Section */}
                <header className="header-section">
                    <div className="profile-container">
                        <img className="profile" src={fabio} alt="Fabio Santo profile picture" />
                    </div>
                    <nav className="social-links">
                        <a href='https://twitter.com/fabiosend' aria-label="Twitter" rel="noreferrer" target="_blank">
                            <img src={twitter} alt="Twitter" />
                        </a>
                        <a href='https://github.com/fabiosanto' aria-label="GitHub" rel="noreferrer" target="_blank">
                            <img src={git} alt="GitHub" />
                        </a>
                        <a href='https://www.linkedin.com/in/fabiosanto/' aria-label="LinkedIn" rel="noreferrer" target="_blank">
                            <img src={link} alt="LinkedIn" />
                        </a>
                        <a href='https://medium.com/@fabiosanto' aria-label="Medium" rel="noreferrer" target="_blank">
                            <img src={medium} alt="Medium" />
                        </a>
                    </nav>
                </header>

                <Container maxWidth="lg">
                    {/* Hero Section */}
                    <section className="hero-section">
                        <div className="hero-content">
                            <div className="hero-text">
                                <h1 className="hero-title">
                                    <span className="wave">👋</span> Hi, I'm Fabio
                                </h1>
                                <p className="hero-subtitle">
                                    I design and develop mobile apps that people love to use.
                                </p>
                                <div className="fun-icons">
                                    🏕️ ⛰️ 🌲 ☀️ ⛵ 🚴 🍕 🌴 🏖️ 🌊
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* About Section */}
                    <section className="about-section">
                        <div className="glass-card">
                            <h2 className="section-title">About Me</h2>
                            <p className="about-text">
                                I've spent 15+ years building mobile products across startups, consultancies and
                                corporates — from a shopping app I started solo on Kotlin Multiplatform to
                                advertising surfaces shipped to millions inside PayPal and Venmo. Working across
                                that range taught me that technology moves fast, but what lasts is the value
                                delivered to users — and that a team gets there fastest by iterating through
                                prototypes, research and data rather than arguing about the problem in the abstract.
                            </p>
                            <p className="about-text">
                                These days I'm a Senior Software Engineer at{' '}
                                <a href="https://dna.inc" target="_blank" rel="noreferrer"><strong>DNA.inc</strong></a>,
                                building mobile experiences for PayPal, Venmo and SiriusXM. Away from the
                                keyboard, you'll usually find me in the mountains, camping, cycling, sailing, or
                                generally anything on the water.
                            </p>
                        </div>
                    </section>

                    {/* Projects Section */}
                    <section className="projects-section">
                        <div className="section-header">
                            <h2 className="section-title">
                                Check out the{' '}
                                <button
                                    className="category-toggle"
                                    onClick={() => toggleFocus(focus)}
                                    aria-label={`Current category: ${focus}. Click to cycle through categories.`}
                                >
                                    {focus}
                                </button>
                                {' '}I've worked on
                            </h2>
                        </div>

                        {items ? (
                            <Grid container spacing={4}>
                                {items.map((item, index) => (
                                    <Grid item xs={12} key={index}>
                                        <div className="project-card glass-card">
                                            <Grid container spacing={4} alignItems="center">
                                                <Grid item xs={12} md={4}>
                                                    <div
                                                        className="project-image"
                                                        style={{ backgroundImage: `url(${item.data().image})` }}
                                                        role="img"
                                                        aria-label={`${item.data().title} preview`}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={8}>
                                                    <div className="project-content">
                                                        <h3 className="project-title">{item.data().title}</h3>
                                                        <p className="project-description">{item.data().body}</p>
                                                        {item.data().link && (
                                                            <a
                                                                className="project-link-btn"
                                                                href={item.data().link}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                View →
                                                            </a>
                                                        )}
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <div className="loading-state">
                                <div className="loading-spinner"></div>
                                <p>Loading amazing projects...</p>
                            </div>
                        )}
                    </section>

                    {/* Footer */}
                    <footer className="footer-section">
                        <p className="footer-text">
                            Let's build something amazing together!
                        </p>
                    </footer>
                </Container>
            </div>
        </div>
    )
}

export default Home;
